import Image from 'components/image'
import Link from 'components/link'
import * as blUrls from 'lib/urls'

export default () => (
  <div className="center-block" style={{ maxWidth: 400 }}>
    <p className="h2 text-bold text-center mvl">🎉 You're all set! 🎉</p>
    <Image
      role="presentation"
      className="img-responsive center-block mbl"
      src="//images.babylist.com/image/upload/f_auto,q_auto/v1567806677/HBB_ekkhgp.jpg"
    />
    <p>We'll send you an email when your Hello Baby Box ships.</p>
    <p>
      For more information,{' '}
      <Link newWindow url={blUrls.helloBabyBoxFaq}>
        visit our FAQs
      </Link>
      .
    </p>
  </div>
)
